import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-lg-500px p-lg-15 mx-auto" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "media/logos/edtrust.png",
    class: "h-125px"
  })
], -1)
const _hoisted_4 = { class: "text-dark mb-10 mt-15" }
const _hoisted_5 = { class: "text-gray-400 fw-bold fs-5" }
const _hoisted_6 = {
  key: 0,
  class: "fv-row mb-10"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-gray-900 fs-6" }, "Email", -1)
const _hoisted_8 = { class: "fv-plugins-message-container" }
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = {
  key: 1,
  class: "fv-row mb-10"
}
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "symbol symbol-50px me-3" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_15 = { class: "text-gray-800 fw-bold text-hover-primary mb-1 fs-6" }
const _hoisted_16 = { class: "text-gray-400 fw-semibold d-block fs-7" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "symbol symbol-50px me-3" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_21 = { class: "text-gray-800 fw-bold text-hover-primary mb-1 fs-6" }
const _hoisted_22 = { class: "text-gray-400 fw-semibold d-block fs-7" }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = {
  key: 2,
  class: "d-flex flex-wrap justify-content-center pb-lg-0"
}
const _hoisted_26 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-primary fw-bolder me-4 ms-3"
}
const _hoisted_27 = { class: "indicator-label" }
const _hoisted_28 = { class: "indicator-progress" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_30 = {
  key: 3,
  class: "notice d-flex bg-light-success rounded border-success border border-dashed p-6 mt-5"
}
const _hoisted_31 = { class: "svg-icon svg-icon-2tx svg-icon-success me-4" }
const _hoisted_32 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_33 = { class: "fw-bold" }
const _hoisted_34 = { class: "text-gray-800 fw-bolder" }
const _hoisted_35 = { class: "fs-6 text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
      onSubmit: _ctx.onSubmitForgotPassword,
      id: "kt_login_password_reset_form",
      "validation-schema": _ctx.forgotPassword
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.t("resetpassword.forgotPassword")), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t("resetpassword.forgotPasswordText")), 1)
        ]),
        (!_ctx.requested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_Field, {
                class: "form-control form-control-solid",
                type: "email",
                placeholder: "name@example.com",
                name: "email",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_ErrorMessage, { name: "email" })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.requested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_v_select, {
                modelValue: _ctx.selectedDB,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDB) = $event)),
                options: _ctx.options,
                placeholder: _ctx.t('login.chooseSchool'),
                "get-option-label": (option) => option.name
              }, {
                option: _withCtx(({ name, logo, adress }) => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("img", {
                        src: logo,
                        class: "",
                        alt: ""
                      }, null, 8, _hoisted_13)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(name), 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(adress), 1)
                    ])
                  ])
                ]),
                "selected-option": _withCtx(({ name, logo, adress }) => [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("img", {
                        src: logo,
                        class: "",
                        alt: ""
                      }, null, 8, _hoisted_19)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(name), 1),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(adress), 1)
                    ])
                  ])
                ]),
                "no-options": _withCtx(({ search, searching, loading }) => [
                  _createTextVNode(_toDisplayString(_ctx.t("login.schoolNotRegistered")), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "options", "placeholder", "get-option-label"]),
              _createVNode(_component_Field, {
                type: "hidden",
                modelValue: _ctx.selectedDB,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDB) = $event)),
                name: "schoolName"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_ErrorMessage, { name: "schoolName" })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.requested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("button", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.t("resetpassword.submit")), 1),
                _createElementVNode("span", _hoisted_28, [
                  _createTextVNode(_toDisplayString(_ctx.t("pleaseWait")) + " ", 1),
                  _hoisted_29
                ])
              ], 512),
              _createVNode(_component_router_link, {
                to: "/sign-in",
                class: "btn btn-lg btn-light-primary fw-bolder"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("resetpassword.cancel")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.requested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("span", _hoisted_31, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen043.svg" })
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("h4", _hoisted_34, _toDisplayString(_ctx.t("resetpassword.resetPasswordReqested")), 1),
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.t("resetpassword.resetPasswordReqestedDesc")), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}